import { SelectProps } from '@amzn/awsui-components-core/select';
import { codeRepoReviewStatusLabels } from '../CodeRepoReviewStatus';
import { CodeRepoReviewStatus } from '@amzn/awscat-pattern-library-service-model';

export const reviewStatusOptions: SelectProps.Option[] = [
  {
    label: codeRepoReviewStatusLabels.get(CodeRepoReviewStatus.NotStarted),
    value: CodeRepoReviewStatus.NotStarted,
  },
  {
    label: codeRepoReviewStatusLabels.get(CodeRepoReviewStatus.InProgress),
    value: CodeRepoReviewStatus.InProgress,
  },
  {
    label: codeRepoReviewStatusLabels.get(CodeRepoReviewStatus.ResolvedSuccessful),
    value: CodeRepoReviewStatus.ResolvedSuccessful,
  },
  {
    label: codeRepoReviewStatusLabels.get(CodeRepoReviewStatus.ResolvedUnsuccessful),
    value: CodeRepoReviewStatus.ResolvedUnsuccessful,
  },
];
